// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_componentDocsScreen__wJvWq {
  min-height: 100vh;
  padding: 2rem; }
  .styles_componentDocsScreen__wJvWq h2 {
    margin-bottom: 0.5rem; }

.styles_header__GMPe\\+ {
  margin-bottom: 1rem;
  border-bottom: 1px solid #e0e0e080;
  padding-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center; }

.styles_componentHeader__406JQ {
  display: flex;
  align-items: center; }

.styles_componentTitle__KdCQg {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  line-height: 1.2;
  padding-right: 1rem; }

.styles_componentKey__bSCvS {
  color: #666;
  font-family: monospace;
  background: #f5f5f5;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  display: inline-block; }

.styles_mainContent__Cfg7C {
  display: flex;
  gap: 3rem;
  min-height: calc(100vh - 10rem); }

.styles_leftSection__thsBo {
  flex: 1 1;
  min-width: 50%;
  max-width: 60%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-height: calc(100vh - 10rem);
  overflow-y: auto;
  padding-right: 1rem; }

.styles_previewContainer__54tXQ {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 2rem;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  position: relative; }

.styles_previewTitle__IUApE {
  position: absolute;
  top: 1rem;
  left: 1rem;
  margin: 0;
  font-size: 1.25rem;
  color: #666;
  z-index: 1; }

.styles_componentPreview__GpNuY {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem; }

.styles_loadingPreview__ESdr1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #666; }

.styles_documentationSection__w2kj5 {
  flex: 1 1;
  min-width: 40%;
  max-width: 50%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-height: calc(100vh - 10rem);
  overflow-y: auto;
  padding-right: 1rem; }

.styles_titleSection__2CSSa,
.styles_introSection__8jzCO,
.styles_principlesSection__Tfc7G,
.styles_usageSection__4-g4l,
.styles_propsSection__QxS9C {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem; }

.styles_componentIntro__m74yW {
  line-height: 1.6;
  color: #333; }

.styles_principlesList__LDS1K {
  display: flex;
  flex-direction: column;
  gap: 1.25rem; }

.styles_principleItem__X5KLD {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border-left: 4px solid #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden; }
  .styles_principleItem__X5KLD::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, #007bff, #0056b3);
    opacity: 0;
    transition: opacity 0.3s ease; }
  .styles_principleItem__X5KLD:hover {
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    transform: translateX(4px) translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 123, 255, 0.2); }
    .styles_principleItem__X5KLD:hover::before {
      opacity: 1; }

.styles_principleContent__nLKQf {
  padding: 1.25rem;
  position: relative; }

.styles_principleText__-0hP\\+ {
  line-height: 1.6;
  color: #2c3e50;
  margin: 0;
  word-wrap: break-word;
  hyphens: auto;
  font-weight: 500;
  position: relative;
  padding-left: 1.5rem; }
  .styles_principleText__-0hP\\+::before {
    content: '✦';
    position: absolute;
    left: 0;
    top: 0;
    color: #007bff;
    font-size: 1.1em;
    font-weight: bold; }

.styles_codeBlock__hMNNM {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 1rem;
  overflow-x: auto; }
  .styles_codeBlock__hMNNM pre {
    margin: 0;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 0.875rem;
    line-height: 1.4;
    color: #333; }

.styles_propsTable__-1J0m {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden; }

.styles_propsHeader__2GsSn {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr;
  gap: 1rem;
  background: #f8f9fa;
  padding: 0.75rem;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600; }

.styles_propRow__7E0V4 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr;
  gap: 1rem;
  padding: 0.75rem;
  border-bottom: 1px solid #f0f0f0; }
  .styles_propRow__7E0V4:last-child {
    border-bottom: none; }

.styles_propName__KSh\\+i {
  font-family: monospace;
  font-weight: 600; }

.styles_propType__yJVTF,
.styles_propDefault__Sqo1X,
.styles_propDescription__xrdei {
  color: #666; }

.styles_loadingContainer__MaaOQ,
.styles_errorContainer__2nNX6,
.styles_notFoundContainer__gqulf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
  text-align: center; }

@media (max-width: 768px) {
  .styles_componentDocsScreen__wJvWq {
    padding: 1rem; }
  .styles_propsHeader__2GsSn,
  .styles_propRow__7E0V4 {
    grid-template-columns: 1fr;
    gap: 0.5rem; }
  .styles_propsHeader__2GsSn {
    display: none; }
  .styles_propRow__7E0V4 {
    padding: 1rem;
    border-bottom: 1px solid #e9ecef; }
    .styles_propRow__7E0V4::before {
      content: attr(data-prop);
      font-weight: 600;
      color: #007bff;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      display: block;
      margin-bottom: 0.5rem; } }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/screens/component-docs/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAiB;EACjB,aAAa,EAAA;EAFf;IAII,qBAAqB,EAAA;;AAIzB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;;AAOrB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACI,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB,EAAA;;AAGzB;EACE,aAAa;EACb,SAAS;EACT,+BAA+B,EAAA;;AAIjC;EACE,SAAO;EACP,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW,EAAA;;AAIb;EACE,SAAO;EACP,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;;;;;EAKE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,gBAAgB;EAChB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB,EAAA;EAPlB;IAUI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oDAAoD;IACpD,UAAU;IACV,6BAA6B,EAAA;EAlBjC;IAsBI,6DAA6D;IAC7D,2CAA2C;IAC3C,6CAA6C,EAAA;IAxBjD;MA2BM,UAAU,EAAA;;AAKhB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB,EAAA;EARtB;IAWI,YAAS;IACT,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,cAAc;IACd,gBAAgB;IAChB,iBAAiB,EAAA;;AAIrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB,EAAA;EALlB;IAQI,SAAS;IACT,wDAAwD;IACxD,mBAAmB;IACnB,gBAAgB;IAChB,WAAW,EAAA;;AAIf;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,gCAAgC,EAAA;EALlC;IAQI,mBAAmB,EAAA;;AAIvB;EACE,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;;;EAGE,WAAW,EAAA;;AAIb;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kBAAkB,EAAA;;AAIpB;EACE;IACE,aAAa,EAAA;EAGf;;IAEE,0BAA0B;IAC1B,WAAW,EAAA;EAGb;IACE,aAAa,EAAA;EAGf;IACE,aAAa;IACb,gCAAgC,EAAA;IAFlC;MAKI,wBAAwB;MACxB,gBAAgB;MAChB,cAAc;MACd,wDAAwD;MACxD,cAAc;MACd,qBAAqB,EAAA,EACtB","sourcesContent":[".componentDocsScreen {\n  min-height: 100vh;\n  padding: 2rem;\n  h2 {\n    margin-bottom: 0.5rem;\n  }\n}\n\n.header {\n  margin-bottom: 1rem;\n  border-bottom: 1px solid #e0e0e080;\n  padding-bottom: 0.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.backButton {\n//   margin-bottom: 1rem;\n}\n\n.componentHeader {\n  display: flex;\n  align-items: center;\n}\n\n.componentTitle {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n  line-height: 1.2;\n  padding-right: 1rem;\n}\n\n.componentKey {\n    color: #666;\n    font-family: monospace;\n    background: #f5f5f5;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    display: inline-block;\n  }\n\n.mainContent {\n  display: flex;\n  gap: 3rem;\n  min-height: calc(100vh - 10rem);\n}\n\n// Left Side - Component Preview, Props, Usage\n.leftSection {\n  flex: 1;\n  min-width: 50%;\n  max-width: 60%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  max-height: calc(100vh - 10rem);\n  overflow-y: auto;\n  padding-right: 1rem;\n}\n\n.previewContainer {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 2rem;\n  min-height: 50vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.previewTitle {\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  margin: 0;\n  font-size: 1.25rem;\n  color: #666;\n  z-index: 1;\n}\n\n.componentPreview {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.loadingPreview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  color: #666;\n}\n\n// Right Side - Documentation\n.documentationSection {\n  flex: 1;\n  min-width: 40%;\n  max-width: 50%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  max-height: calc(100vh - 10rem);\n  overflow-y: auto;\n  padding-right: 1rem;\n}\n\n.titleSection,\n.introSection,\n.principlesSection,\n.usageSection,\n.propsSection {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.componentIntro {\n  line-height: 1.6;\n  color: #333;\n}\n\n.principlesList {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.principleItem {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 12px;\n  border-left: 4px solid #007bff;\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(90deg, #007bff, #0056b3);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  \n  &:hover {\n    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n    transform: translateX(4px) translateY(-2px);\n    box-shadow: 0 4px 16px rgba(0, 123, 255, 0.2);\n    \n    &::before {\n      opacity: 1;\n    }\n  }\n}\n\n.principleContent {\n  padding: 1.25rem;\n  position: relative;\n}\n\n.principleText {\n  line-height: 1.6;\n  color: #2c3e50;\n  margin: 0;\n  word-wrap: break-word;\n  hyphens: auto;\n  font-weight: 500;\n  position: relative;\n  padding-left: 1.5rem;\n  \n  &::before {\n    content: '✦';\n    position: absolute;\n    left: 0;\n    top: 0;\n    color: #007bff;\n    font-size: 1.1em;\n    font-weight: bold;\n  }\n}\n\n.codeBlock {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 1rem;\n  overflow-x: auto;\n\n  pre {\n    margin: 0;\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 0.875rem;\n    line-height: 1.4;\n    color: #333;\n  }\n}\n\n.propsTable {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.propsHeader {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 2fr;\n  gap: 1rem;\n  background: #f8f9fa;\n  padding: 0.75rem;\n  border-bottom: 1px solid #e0e0e0;\n  font-weight: 600;\n}\n\n.propRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 2fr;\n  gap: 1rem;\n  padding: 0.75rem;\n  border-bottom: 1px solid #f0f0f0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.propName {\n  font-family: monospace;\n  font-weight: 600;\n}\n\n.propType,\n.propDefault,\n.propDescription {\n  color: #666;\n}\n\n// Loading and Error States\n.loadingContainer,\n.errorContainer,\n.notFoundContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 1rem;\n  text-align: center;\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .componentDocsScreen {\n    padding: 1rem;\n  }\n\n  .propsHeader,\n  .propRow {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .propsHeader {\n    display: none;\n  }\n\n  .propRow {\n    padding: 1rem;\n    border-bottom: 1px solid #e9ecef;\n\n    &::before {\n      content: attr(data-prop);\n      font-weight: 600;\n      color: #007bff;\n      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n      display: block;\n      margin-bottom: 0.5rem;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentDocsScreen": `styles_componentDocsScreen__wJvWq`,
	"header": `styles_header__GMPe+`,
	"componentHeader": `styles_componentHeader__406JQ`,
	"componentTitle": `styles_componentTitle__KdCQg`,
	"componentKey": `styles_componentKey__bSCvS`,
	"mainContent": `styles_mainContent__Cfg7C`,
	"leftSection": `styles_leftSection__thsBo`,
	"previewContainer": `styles_previewContainer__54tXQ`,
	"previewTitle": `styles_previewTitle__IUApE`,
	"componentPreview": `styles_componentPreview__GpNuY`,
	"loadingPreview": `styles_loadingPreview__ESdr1`,
	"documentationSection": `styles_documentationSection__w2kj5`,
	"titleSection": `styles_titleSection__2CSSa`,
	"introSection": `styles_introSection__8jzCO`,
	"principlesSection": `styles_principlesSection__Tfc7G`,
	"usageSection": `styles_usageSection__4-g4l`,
	"propsSection": `styles_propsSection__QxS9C`,
	"componentIntro": `styles_componentIntro__m74yW`,
	"principlesList": `styles_principlesList__LDS1K`,
	"principleItem": `styles_principleItem__X5KLD`,
	"principleContent": `styles_principleContent__nLKQf`,
	"principleText": `styles_principleText__-0hP+`,
	"codeBlock": `styles_codeBlock__hMNNM`,
	"propsTable": `styles_propsTable__-1J0m`,
	"propsHeader": `styles_propsHeader__2GsSn`,
	"propRow": `styles_propRow__7E0V4`,
	"propName": `styles_propName__KSh+i`,
	"propType": `styles_propType__yJVTF`,
	"propDefault": `styles_propDefault__Sqo1X`,
	"propDescription": `styles_propDescription__xrdei`,
	"loadingContainer": `styles_loadingContainer__MaaOQ`,
	"errorContainer": `styles_errorContainer__2nNX6`,
	"notFoundContainer": `styles_notFoundContainer__gqulf`
};
export default ___CSS_LOADER_EXPORT___;
